import React from 'react';
import { SaldoContribuicoesFaelceEntidade } from '@entidades';

import { Badge, Box } from '@intech/web-ui';

interface IProps {
  saldo: SaldoContribuicoesFaelceEntidade | undefined;
  referencia: string;
}

export const SaldoAcomulado: React.FC<IProps> = ({
  saldo,
  referencia
}) => {

  function ToMoney(Valor: number | undefined, FractionDigits = -1) {
    var options: any = {
      minimumFractionDigits: 2
    }
    if (FractionDigits > -1) {
      options = {
        minimumFractionDigits: FractionDigits,
        maximumFractionDigits: FractionDigits
      }
    }
    if (Valor === undefined)
      return 0;
    return (
      Valor.toLocaleString('pt-br', options)
    );
  }

  if (saldo === undefined) {
    return null;
  }

  return (
    <Box title={"Saldo Acumulado Atualizado"} badgeText={`Referência em ${referencia}`}>
      <div className={"table-responsive"}>
        <table className={"table table-striped table-sm"}>
          <tbody>

            <tr>
              <td style={{ "textAlign": "left" }}>
                {"Contribuições do Participante"}
              </td>
              <td style={{ "textAlign": "right" }}>
                R$ {ToMoney(saldo.ContribTotal, 2)}
              </td>
            </tr>

          </tbody>
        </table>
      </div>

    </Box>
  );
}